import { render } from "./IOT.vue?vue&type=template&id=e4b73662&scoped=true"
import script from "./IOT.vue?vue&type=script&lang=js"
export * from "./IOT.vue?vue&type=script&lang=js"

import "./IOT.vue?vue&type=style&index=0&id=e4b73662&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b73662"]])

export default __exports__